export interface ExternalLink {
  href: string;
  labelKey: string;
}

const keyI18n = "translations.acessibility";

export const externalLinks: ExternalLink[] = [
  {
    labelKey: `${keyI18n}.officialDiary`,
    href: "https://diariooficial.fortaleza.ce.gov.br/",
  },
  {
    labelKey: `${keyI18n}.informationAccess`,
    href:
      "https://acessoainformacao.fortaleza.ce.gov.br/sistema/site/index.html?ReturnUrl=%2fsistema%2f",
  },
  {
    labelKey: `${keyI18n}.transparency`,
    href: "https://portaltransparencia.fortaleza.ce.gov.br/#/",
  },
  {
    labelKey: `${keyI18n}.services`,
    href:
      "https://fortalezadigital.fortaleza.ce.gov.br/ords/r/fortaleza-digital/portal/home",
  },
  {
    labelKey: `${keyI18n}.legislation`,
    href: "https://sapl.fortaleza.ce.leg.br/",
  },
];
